/**
 * Lead custom tags API (`GET/PUT /crm/api/leads/custom-tags/`).
 */

export function leadCustomTagsUrl(leadSource, leadRefId) {
  const params = new URLSearchParams({
    lead_source: leadSource,
    lead_ref_id: String(leadRefId),
  })
  return `/crm/api/leads/custom-tags/?${params.toString()}`
}

export function getLeadCustomTags(axios, leadSource, leadRefId) {
  return axios.get(leadCustomTagsUrl(leadSource, leadRefId))
}

export function putLeadCustomTags(axios, leadSource, leadRefId, tags) {
  return axios.put(leadCustomTagsUrl(leadSource, leadRefId), { tags })
}
